import YouTubeVideo from 'components/YouTubeVideo'
import Masonry from 'masonry-layout'

import Site from 'stores/Site'
import Page from 'classes/Page'

export default class Event extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()
        this.initVideo()
        this.initGallery()
    }

    initVideo() {
        const section = Site.page.querySelector('.s-video')

        if (!section) return

        this.video = new YouTubeVideo(section)
    }

    initGallery() {
        if (Site.isMobile) return

        const wrapper = Site.page.querySelector('.s-gallery .swiper-wrapper')

        if (!wrapper) return

        this.masonry = new Masonry( wrapper, {
            itemSelector: '.image',
            gutter: 32,
            percentPosition: true
        })

        wrapper.querySelectorAll('.image').forEach(img => {
            if (img.complete) return

            img.addEventListener('load', () => this.masonry.layout(), { once: true })
        })
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}